import {intlShape, utils} from '@wallaby-ui/core';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages, injectIntl} from 'react-intl';

import styles from './GridFilterSubmitButton.less';

const I18N = defineMessages({
  TITLE: {
    id: 'filter.submit.title',
    defaultMessage: 'Apply filter',
    description: 'title text for submit filter button',
  },
  LABEL: {
    id: 'filter.submit.label',
    defaultMessage: 'APPLY',
    description: 'label for submit filter button',
  },
});

class GridFilterSubmitButton extends React.PureComponent {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  handleClick(event) {
    const {handleClick} = this.props;
    if (event) {
      event.stopPropagation();
    }
    handleClick();
  }

  handleKeyDown(event) {
    const {handleClick} = this.props;
    if (event.key === 'Enter' || event.key === ' ') {
      event.stopPropagation();
      handleClick();
    }
    return true;
  }

  render() {
    const {buttonText, className, intl, isDisabled, tabIndex, titleText} =
      this.props;
    return (
      <button
        type={'submit'}
        className={classNames(
          className,
          styles.dlGridFilterSubmitButton,
          'float-end',
          {[styles.dlDisabledButton]: isDisabled}
        )}
        title={utils.TranslateUtils.translate(
          {...I18N.TITLE, id: titleText},
          intl
        )}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        disabled={isDisabled}
        tabIndex={tabIndex}
      >
        {utils.TranslateUtils.translate({...I18N.LABEL, id: buttonText}, intl)}
      </button>
    );
  }
}

GridFilterSubmitButton.displayName = 'GridFilterSubmitButton';

GridFilterSubmitButton.propTypes = {
  buttonText: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  handleClick: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  isDisabled: PropTypes.bool,
  tabIndex: PropTypes.number,
  titleText: PropTypes.string,
};

GridFilterSubmitButton.defaultProps = {
  className: '',
  buttonText: 'filter.submit.label',
  isDisabled: false,
  tabIndex: 0,
  titleText: 'filter.submit.title',
};

export default injectIntl(GridFilterSubmitButton);
